import { EMPTY_STRING } from '../../../../../constants/common'
import { useUk, useUserData } from '../../../../../hooks'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import { useRequestProfileHeaderDescription } from '../useRequestProfileHeaderDescription'
import { useRequestProfileHeaderTranslation } from '../useRequestProfileHeaderTranslation'

export function useRequestProfileHeaderDescriptionSection() {
  const currentUser = useUserData()
  const uk = useUk()

  const { requestData } = useRequestProfileContext()

  const requestDescriptionHtml = requestData?.text ?? EMPTY_STRING

  const ukLanguageCode = uk?.language?.code ?? null
  const userLanguageCode = currentUser?.language?.code ?? ukLanguageCode

  const {
    descriptionHtml,
    isRequestTranslateOpen,
    requestTranslateProps,
    resetTranslation,
    onClickOpenRequestTranslate,
  } = useRequestProfileHeaderTranslation({
    requestText: requestDescriptionHtml,
    ukLanguageCode,
    userLanguageCode,
  })

  const { canEditDescription, onClickEditDescription } =
    useRequestProfileHeaderDescription({
      requestDescriptionHtml,
      onAfterSubmit: resetTranslation,
    })

  return {
    canEditDescription,
    descriptionHtml,
    hasDescriptionContent: Boolean(descriptionHtml),
    isRequestTranslateOpen,
    requestTranslateProps,
    onClickEditDescription,
    onClickOpenRequestTranslate,
  }
}
